import * as React from 'react'

const SvgHearthIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_4612_41922)">
      <path
        d="M14.5835 0.764282C13.6451 0.778878 12.7272 1.04083 11.9224 1.52367C11.1177 2.00652 10.4546 2.69317 10.0001 3.51428C9.54566 2.69317 8.88257 2.00652 8.07783 1.52367C7.27308 1.04083 6.35517 0.778878 5.41679 0.764282C3.92091 0.829274 2.51155 1.48366 1.49661 2.58448C0.481678 3.68529 -0.0563308 5.14305 0.000128002 6.63928C0.000128002 12.2851 9.13013 18.806 9.51846 19.0826L10.0001 19.4235L10.4818 19.0826C10.8701 18.8076 20.0001 12.2851 20.0001 6.63928C20.0566 5.14305 19.5186 3.68529 18.5036 2.58448C17.4887 1.48366 16.0793 0.829274 14.5835 0.764282ZM10.0001 17.3718C7.28929 15.3468 1.66679 10.3718 1.66679 6.63928C1.60983 5.58488 1.9721 4.55072 2.6746 3.76237C3.37709 2.97401 4.36282 2.49541 5.41679 2.43095C6.47077 2.49541 7.45649 2.97401 8.15899 3.76237C8.86149 4.55072 9.22376 5.58488 9.16679 6.63928H10.8335C10.7765 5.58488 11.1388 4.55072 11.8413 3.76237C12.5438 2.97401 13.5295 2.49541 14.5835 2.43095C15.6374 2.49541 16.6232 2.97401 17.3257 3.76237C18.0282 4.55072 18.3904 5.58488 18.3335 6.63928C18.3335 10.3734 12.711 15.3468 10.0001 17.3718Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_4612_41922">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgHearthIcon
